/* eslint no-process-env:0 */
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}



// WEBPACK FOOTER //
// ./src/app/redux/store/configureStore.js